// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideSendHorizonal as RawLucideSendHorizonal } from "lucide-react";
export const LucideSendHorizonal = /* @__PURE__ */ createIcon(RawLucideSendHorizonal, "LucideSendHorizonal", 2);
